/** tempexp_14728-full-file */
import { Icon16MailOutline, Icon20MailOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { memo } from 'react';
import { Avatar } from 'reactApp/ui/Avatar/Avatar';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { NameComponent } from 'reactApp/ui/Name/Name';

import styles from './Destination.css';

interface DestinationProps {
    className?: string;
    destination?: string;
    author?: { name?: string; email: string };
    openAttachLetter?: () => void;
    isAttaches?: boolean;
    size?: 'm' | 'l';
}

export const Destination = memo<DestinationProps>(function Destination({
    className,
    destination,
    author,
    openAttachLetter,
    isAttaches,
    size = 'l',
}) {
    const Icon = size === 'l' ? Icon20MailOutline : Icon16MailOutline;

    return (
        <div
            className={classNames(styles.root, className, {
                [styles[`size_${size}`]]: !!size,
            })}
        >
            {author && (
                <div
                    className={classNames(styles.avatar, {
                        [styles.avatarAttaches]: isAttaches,
                    })}
                >
                    <Hint text={author.name || author.email}>
                        <div>
                            <Avatar size={size === 'l' ? 32 : 28} email={author.email} name={author.name} />
                        </div>
                    </Hint>
                    {isAttaches && (
                        <Hint text="Перейти к письму">
                            <div className={styles.mailIcon} onClick={openAttachLetter}>
                                <Icon />
                            </div>
                        </Hint>
                    )}
                </div>
            )}
            {destination && <NameComponent className={styles.name} name={destination} showTooltip truncate />}
        </div>
    );
});
